import { ExpandArrowIcon, MinusIcon } from '@sketchnote/icons';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

export const FormTimer = ({
  timeAllowed,
  onTimeEnd,
}: {
  timeAllowed: number;
  onTimeEnd?: () => void;
}) => {
  const [timeRemaining, setTimeRemaining] = useState<number>(timeAllowed);
  const [intervalId, setIntervalId] = useState<ReturnType<typeof setInterval>>();
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeRemaining((p) => p - 1);
    }, 1000);
    setIntervalId(intervalId);
  }, []);

  useEffect(() => {
    if (timeRemaining < 1 && !!intervalId) {
      clearInterval(intervalId);
      setIntervalId(undefined);
      onTimeEnd?.();
    }
  }, [timeRemaining, intervalId]);

  const toggleExpanded = () => {
    setExpanded((p) => !p);
  };

  const [hours, mins, secs] = new Date((timeRemaining >= 0 ? timeRemaining : 0) * 1000)
    .toISOString()
    .slice(11, 19)
    .split(':');
  const formattedTimer = `${hours}h:${mins}m:${secs}s`;

  const lowTime = timeRemaining < 120;

  return (
    <div
      className={classNames(
        'fixed top-24 right-24 p-10 rounded-lg shadow transition-all duration-200 bg-white z-10 w-64'
      )}
      style={{ width: 270 }}
    >
      <div className="relative">
        <div className="overflow-hidden">
          <div
            className={classNames('transition-all duration-200')}
            style={{ height: 24, marginTop: expanded ? 0 : -24 }}
          >
            ⏰ Time left
          </div>
        </div>
        <div
          className={classNames('absolute right-0 transition-all duration-200 cursor-pointer')}
          style={{ top: expanded ? 0 : 10 }}
          onClick={toggleExpanded}
        >
          {expanded ? (
            <MinusIcon className="text-gray-600 -mt-12" />
          ) : (
            <ExpandArrowIcon className="text-gray-600" />
          )}
        </div>
        <div className={classNames('text-2xl font-bold', lowTime && 'text-red-600')}>
          {formattedTimer}
        </div>
        <div className={classNames('overflow-hidden transition-all duration-200')}>
          <div
            className="text-xs text-gray-600 transition-all duration-200"
            style={{ height: 18, marginTop: expanded && lowTime ? 0 : -18 }}
          >
            Hurry! Your form is about to get submitted.
          </div>
        </div>
      </div>
    </div>
  );
};
